import { VisuallyHidden } from '../common/VisuallyHidden.tsx';

/** Visually-hidden data table — the text equivalent every chart pairs with. */
export function ChartTable({
  caption,
  columns,
  rows,
  id,
}: {
  caption: string;
  columns: string[];
  rows: (string | number)[][];
  id?: string;
}) {
  return (
    <VisuallyHidden as="div">
      <table id={id}>
        <caption>{caption}</caption>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c} scope="col">
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              {r.map((cell, j) => (
                <td key={j}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </VisuallyHidden>
  );
}
